module.exports = __webpack_public_path__ + "img/Daniel_Schonborn.ff4c3a0d.png";